import React from "react";
import "./skeleton.css";

const skeletonCard = ({ type = "vertical" }) => {

    if (type === "hero") {
        return (
            <div className="rs-skeleton rs-skeleton-hero">
                <div className="rs-skeleton-box rs-skeleton-image"></div>

                <div className="rs-skeleton-content">
                    <div className="rs-skeleton-line rs-skeleton-tag"></div>
                    <div className="rs-skeleton-line rs-skeleton-title"></div>
                    <div className="rs-skeleton-line rs-skeleton-title short"></div>
                    <div className="rs-skeleton-line rs-skeleton-text"></div>
                    <div className="rs-skeleton-line rs-skeleton-meta"></div>
                </div>
            </div>
        );
    }

    if (type === "horizontal") {
        return (
            <div className="rs-skeleton rs-skeleton-horizontal">
                <div className="rs-skeleton-box rs-skeleton-thumb"></div>

                <div className="rs-skeleton-content">
                    <div className="rs-skeleton-line rs-skeleton-tag"></div>
                    <div className="rs-skeleton-line rs-skeleton-title"></div>
                    <div className="rs-skeleton-line rs-skeleton-text"></div>
                </div>
            </div>
        );
    }

    if (type === "feature") {
        return (
            <div className="rs-skeleton rs-skeleton-feature">
                <div className="rs-skeleton-content">
                    <div className="rs-skeleton-line rs-skeleton-tag"></div>
                    <div className="rs-skeleton-line rs-skeleton-title"></div>
                    <div className="rs-skeleton-line rs-skeleton-title short"></div>
                    <div className="rs-skeleton-line rs-skeleton-text"></div>
                    <div className="rs-skeleton-line rs-skeleton-meta"></div>
                </div>

                <div className="rs-skeleton-box rs-skeleton-image"></div>
            </div>
        );
    }

    if (type === "imageCard") {
        return (
            <div className="rs-skeleton rs-skeleton-image-card">
                <div className="rs-skeleton-box rs-skeleton-image"></div>

                <div className="rs-skeleton-content">
                    <div className="rs-skeleton-line rs-skeleton-tag"></div>
                    <div className="rs-skeleton-line rs-skeleton-title"></div>
                    <div className="rs-skeleton-line rs-skeleton-text"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="rs-skeleton rs-skeleton-vertical">
            <div className="rs-skeleton-box rs-skeleton-image"></div>

            <div className="rs-skeleton-content">
                <div className="rs-skeleton-line rs-skeleton-tag"></div>
                <div className="rs-skeleton-line rs-skeleton-title"></div>
                <div className="rs-skeleton-line rs-skeleton-text"></div>
                <div className="rs-skeleton-line rs-skeleton-meta"></div>
            </div>
        </div>
    );
};

export default skeletonCard;